import React, { useMemo } from 'react'
import { typeDisplayAnnotation } from '../../shared/constants'
import PdfViewer from '../PdfViewer/PdfViewer'
import ImgViewer from '../ImgViewer/ImgViewer'

function AnnotationViewer({ typeDisplay }) {
  const viewer = useMemo(() => {
    switch (typeDisplay) {
      case typeDisplayAnnotation.IMAGE:
        return <ImgViewer />
      case typeDisplayAnnotation.PDF:
        return <PdfViewer />
      default:
        return null
    }
  }, [typeDisplay])

  return viewer
}

export default AnnotationViewer
